import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize24;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.99054 0.951385C4.40881 0.951385 3.8509 1.18248 3.43956 1.59382C3.02821 2.00517 2.79712 2.56308 2.79712 3.14481V16.1322C2.79712 16.7139 3.02821 17.2718 3.43956 17.6832C3.8509 18.0945 4.40881 18.3256 4.99054 18.3256H9.54822C9.86303 18.3256 10.1182 18.0704 10.1182 17.7556C10.1182 17.4408 9.86303 17.1856 9.54822 17.1856H4.99054C4.71116 17.1856 4.44321 17.0746 4.24566 16.8771C4.0481 16.6795 3.93712 16.4116 3.93712 16.1322V3.14481C3.93712 2.86542 4.0481 2.59748 4.24566 2.39993C4.44321 2.20237 4.71116 2.09139 4.99054 2.09139H10.1025V7.20337C10.1025 7.51817 10.3577 7.77337 10.6725 7.77337H15.7845V9.1087V10.9493C15.7845 11.2641 16.0397 11.5193 16.3545 11.5193C16.6693 11.5193 16.9245 11.2641 16.9245 10.9493V9.1087V7.20337C16.9245 7.12115 16.9071 7.043 16.8758 6.97241C16.8522 6.91917 16.8201 6.8688 16.7794 6.82339C16.7716 6.8147 16.7636 6.80625 16.7553 6.79806L11.0779 1.12068C10.9746 1.01615 10.8311 0.951385 10.6725 0.951385C10.6725 0.951385 10.6725 0.951385 10.6725 0.951385H4.99054ZM11.2425 2.8975V6.63337H14.9784L11.2425 2.8975Z"
          fill={color}
        />
        <path
          d="M18.4101 11.7793C18.7066 11.4827 19.1088 11.3162 19.5281 11.3162C19.7357 11.3162 19.9413 11.3571 20.1331 11.4365C20.325 11.516 20.4992 11.6324 20.6461 11.7793C20.7929 11.9261 20.9093 12.1004 20.9888 12.2922C21.0682 12.484 21.1091 12.6896 21.1091 12.8972C21.1091 13.1048 21.0682 13.3104 20.9888 13.5022C20.9093 13.6941 20.7929 13.8684 20.6461 14.0152L12.5501 22.1114L9.56885 22.8567L10.3142 19.8755L18.4101 11.7793Z"
          stroke={color}
          strokeWidth="1.13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 24 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'apply');
export default IconComponent;
